import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Content, Modal } from "components/trunx";

import PzButton from "../form/PzButton";
import PzModal from "../modal/PzModal";
import { PzTitle } from "../text/PzTitle";

interface TransactionErrorModalProps {
    onClose: () => void;
}

export default function TransactionErrorModal({ onClose }: TransactionErrorModalProps): JSX.Element {
    function renderIcon() {
        return <FontAwesomeIcon icon={faExclamationCircle} />;
    }

    return (
        <PzModal isActive>
            <Modal.Card.Head>
                <PzTitle style={{ marginBottom: "0" }}>{renderIcon()} Det oppsto et feil ved kjøpet</PzTitle>
            </Modal.Card.Head>
            <Modal.Card.Body style={{ maxWidth: "35rem" }}>
                <Content>
                    Det oppsto et problem når vi forsøkte å gjennomføre kjøpet. Dette er vår feil, ikke din. Hvis feilen
                    vedvarer, vennligst forsøk å logge inn på nytt.
                </Content>
            </Modal.Card.Body>
            <Modal.Card.Foot>
                <PzButton isPrimary onClick={() => onClose()}>
                    Lukk
                </PzButton>
            </Modal.Card.Foot>
        </PzModal>
    );
}
